import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit {
  @Input() message: string | undefined;
  @Input() diameter: number | string = 24;
  @Input() color: 'primary' | 'accent' | 'warn' | 'light' = 'primary';

  constructor() {}

  ngOnInit() {}
}
